function showSaveUserFailSnackbar({ state }) {
  state.merge('client.forms.snackbar', { show: true, success: false })
}

export default showSaveUserFailSnackbar



// WEBPACK FOOTER //
// ./src/modules/user/actions/showSaveUserFailSnackbar.js